import { SvgIcon, SvgIconProps } from "@mui/material";

/**
 * Clock with a counter-clockwise arrow — the `Re-Open` status badge.
 *
 * Single-colour: every stroke is `currentColor`, so the badge sets the whole
 * glyph through `htmlColor` (gold.600). Kept on the supplied 16 viewBox rather
 * than rescaled to 24 — `SvgIcon` scales it to fit, and 14 icons in this folder
 * already do the same.
 */
export const ReopenIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="m4.25 8-1.5 1.5L1.25 8"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M2.75 8c0 .463.057.91.157 1.343M14.75 8a6 6 0 1 0-12 0M8.75 14a6 6 0 0 0 6-6M3.836 11.437A5.99 5.99 0 0 0 8.75 14"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M10.997 9.914 8.563 8.465V5.323"
      />
    </svg>
  </SvgIcon>
);
